import { TFutureRecord } from "../../../../types/dto/FuturesRecordDto";
import { FuturesRaw } from "../../../../types/FuturesRecord";
import { dateService } from "../../../../services/date";

const mapFuturesRecordsDtoToFuturesRecords = (
  futureRecords: Array<TFutureRecord>
): Array<FuturesRaw> =>
  futureRecords.map(
    ({
      AreaID,
      Volume,
      LowPrice,
      OpenPrice,
      HighPrice,
      ClosePrice,
      ContractMonth,
      ReportPeriod,
      OpenInterest,
    }) => {
      try {
        return {
          areaID: AreaID,
          volume: Volume,
          lowPrice: Number(LowPrice),
          openPrice: Number(OpenPrice),
          highPrice: Number(HighPrice),
          closePrice: Number(ClosePrice),
          contractMonth: dateService.parseApiDate(ContractMonth),
          reportPeriod: dateService.parseApiDate(ReportPeriod),
          openInterest: OpenInterest,
        };
      } catch (error) {
        console.error('Error parsing futures record dates:', error, { ContractMonth, ReportPeriod });
        return {
          areaID: AreaID,
          volume: Volume,
          lowPrice: Number(LowPrice),
          openPrice: Number(OpenPrice),
          highPrice: Number(HighPrice),
          closePrice: Number(ClosePrice),
          contractMonth: new Date(ContractMonth),
          reportPeriod: new Date(ReportPeriod),
          openInterest: OpenInterest,
        };
      }
    });

export default mapFuturesRecordsDtoToFuturesRecords;
